import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'
// import AppBar from './components/AppBar'
import Home from './pages/Home'

function App() {
  return (
    <Router>
      {/* <AppBar /> */}
      <Switch>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
